const uiTypes = {
  toggle_nav: 'toggle_nav',
  dark_theme: 'dark_theme',
  change_theme: 'change_theme',
};

export default uiTypes;
